<template>
  <div class="c-results">
    <h3 v-if="count > 0">{{ count }} Audi</h3>
    <h3 v-if="count == 0">Brak ofert o podanych kryteriach wyszukiwaniach</h3>
    <div class="c-results-row">
        <div class="c-results-item" v-for="offer in offers" >
          <a v-bind:href="'http://krotoskicichy.com/oferta/'+offer.id+'/'" target="_blank">
          <div class="c-results-item-img" v-if="offer.photos.split(';')[0]">
            <img v-bind:src="offer.photos.split(';')[0]" v-bind:alt="offer.brand+' '+offer.model">
          </div>
          <div class="c-results-item-head">
            <h2>{{offer.brand}} {{offer.model}}</h2>
            <h3>{{offer.title}}</h3>
          </div>
          <div class="c-results-item-price">
            <strong>{{formatPrice.to(parseInt(offer.price))}}</strong>
          </div>
          <div class="c-results-item-params">
            <p>
              <strong>Moc maksymalna:</strong>&nbsp;<span>{{offer.power}} KM</span>
            </p>
            <p>
              <strong>Rodzaj paliwa:</strong>&nbsp;<span>{{offer.fuel}}</span>
            </p>
            <p>
              <strong>Rodzaj napędu:</strong>&nbsp;<span>{{offer.drive}}</span>
            </p>
            <p>
              <strong>Typ nadwozia:</strong>&nbsp;<span>{{offer.body}}</span>
            </p>
          </div>
        </a>
        <span class="c-results-item-btn" v-on:click="showForm(offer.brand+' '+offer.model+' link: http://krotoskicichy.com/oferta/'+offer.id+'/');">Zapytaj o szczegóły</span>
        </div>
    </div>
  </div>


</template>

<script>
import wNumb from 'wnumb';

export default {
  name: 'Results',
  props: [
    'ModelList',
    'Fueltype',
    'Geartype',
    'Transmissiontype',
    'Price' ,
    'ModelCount',
    'page'
  ],
  data: function () {
    return {
      offers: {},
      pages:0,
      limit:12,
      model:Array(),
      formatPrice: wNumb({decimals: 0,prefix: '' ,suffix: ' PLN', thousand: ' '}),
      count:String,
      salon_id: 2,
      modelName: ''
    }
  },
  methods: {
    getModels: function getModels() {
        var paramsy = {};
        paramsy['limit'] = this.limit;
        paramsy['page_nb'] = this.page;
        paramsy['localization'] = 2;
        paramsy['page'] = 'samochody-nowe';
        paramsy['sortby'] = 'newest';
        paramsy['brand'] = 'Audi';
        paramsy['year_from'] = '2018';
        paramsy['year_to'] = '2019';
        paramsy['localization'] = this.salon_id;
        paramsy['model'] = this.model;

        if (this.Price.from.value) {
          paramsy['price_from'] = this.Price.from.value;
        }
        if (this.Price.to.value) {
          paramsy['price_to'] = this.Price.to.value;
        }

        if (this.ModelList != null) {
          for (var key in this.ModelList) {
            if (this.ModelList[key].selected == true) {
              paramsy['model'] = this.ModelList[key].id;
            }
          }
        }

        if (this.Geartype != null) {
          for (var key in this.Geartype) {
            if (this.Geartype[key].selected == true) {
              paramsy['transmission'] = this.Geartype[key].id;
            }
          }
        }

        if (this.Fueltype != null) {
          for (var key in this.Fueltype) {
            if (this.Fueltype[key].selected == true) {
              paramsy['fuel'] = this.Fueltype[key].id;
            }
          }
        }

        if (this.Transmissiontype != null) {
          for (var key in this.Transmissiontype) {
            if (this.Transmissiontype[key].selected == true) {
              paramsy['drive'] = this.Transmissiontype[key].id;
            }
          }
        }

        var _this = this;
        this.axios.get('http://krotoskicichy.com/api/list.php', {params: paramsy})
        .then(function (response) {
          var lastIndex = Object.keys(_this.offers).length
          for (var key in response.data.adverts) {
            _this.offers[lastIndex+Number(key)] = response.data.adverts[key];
          }
          console.log(_this.offers);
          _this.$forceUpdate();

          // _this.offers = response.data.adverts

          if (response.data.count / _this.limit > 0 && response.data.count / _this.limit < 1) {
            _this.pages = 1;
          } else {
            _this.pages = Math.round(response.data.count / _this.limit);
          }
          _this.count = response.data.count
          _this.$emit('ModelCount', response.data.count)
        }).catch(function (error) {
          window.alert(error);
        });
      },
      showForm: function(val){
        this.$emit('ShowForm', true);
        this.$emit('ModelName', val);
      }
    },
    watch:{
      pages: function(value){
        this.$emit('pages', value);
      },
      ModelList:{
        handler: function(){
          this.page = 1;
          this.$emit('page', 1);
          this.$emit('pages', 1);
          this.offers = {};
          this.getModels()
        },
        deep: true
      },
      Fueltype:{
        handler: function(){
          this.page = 1;
          this.$emit('page', 1);
          this.$emit('pages', 1);
          this.offers = {};
          this.getModels()
        },
        deep: true
      },
      Geartype:{
        handler: function(){
          this.page = 1;
          this.$emit('page', 1);
          this.$emit('pages', 1);
          this.offers = {};
          this.getModels()
        },
        deep: true
      },
      Transmissiontype:{
        handler: function(){
          this.page = 1;
          this.$emit('page', 1);
          this.$emit('pages', 1);
          this.offers = {};
          this.getModels()
        },
        deep: true
      },
      Price:{
        handler: function(){
          this.page = 1;
          this.$emit('page', 1);
          this.$emit('pages', 1);
          this.offers = {};
          this.getModels()
        },
        deep: true
      },
      page:function(){
        this.getModels();
      }
    },
    created:function(){
      this.page = 1;
      this.$emit('page', 1);
      this.$emit('pages', 1);
      this.getModels()
    }
}
</script>
<style lang="scss">
  .c-results{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding:2rem 0 0 0;
    &-row{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      border-top: 1px solid #b3b3b3;
    }
    &-item{
      position: relative;
      width: calc(100% * (1/3));
      max-width: calc(100% * (1/3) - 30px);
      // @media(max-width: 1000px){
      //   width: calc(100% * (1/3));
      //   max-width: calc(100% * (1/3) - 30px);
      // }
      a{
        color: #000;
      }
      @media(max-width: 960px){
        width: calc(100% * (1/2));
        max-width: calc(100% * (1/2) - 30px);
      }
      @media(max-width: 780px){
        width: calc(100% * (1/1));
        max-width: calc(100% * (1/1) - 30px);
      }
      flex-grow: 1;
      margin: 15px 30px 15px 0px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      border-bottom: 1px solid #d5d5d5;
      &-img{
        img{
          width: 100%;
        }
      }
      &-head{
        h2{
          margin: 0;
          font-size: 1.75rem;
          margin-top: 1rem;
        }
        h3{
          font-weight: normal;
          font-size: 1rem;
          margin: .5rem 0;
          color: #a0a0a0;
        }
      }
      &-price{
        padding: .25rem 0;
        strong{
          font-size: 1.25rem;
        }
      }
      &-btn{
        margin-left: auto;
        background-color: #c03;
        font-weight: bold;
        color: #fff;
        width: 100%;
        text-align: center;
        padding: .5rem 1rem;
        margin-bottom: 1rem;
        cursor: pointer;
      }
      &-params{

      }
      &-details{
        position: absolute;
        top:0;
        right: 0;
        width: 30px;
        height: 30px;
        background: rgba(0, 0, 0, 0.7) url('../assets/images/eye.png') no-repeat center;
        background-size: 60%;
        display: block;
        z-index: 999;
      }
    }
  }
</style>
